module.exports = __webpack_public_path__ + "media/images/front/sp/article/thum07-e3ac8cafcc941f03cc78ca23a2d62c3e.png";